import React, { useEffect, useState } from "react";
import {
  getMediaSession,
  subscribeMediaSession,
} from "./MediaSessionManager";

// NapflixOS Now Playing Overlay v10.1
// Passive media session display only: no controls, focus, or keyboard handling.
export default function NowPlayingOverlay() {
  const [mediaSession, setMediaSession] = useState(getMediaSession());

  useEffect(() => {
    setMediaSession(getMediaSession());
    return subscribeMediaSession(setMediaSession);
  }, []);

  const hasActiveMedia =
    !!mediaSession.title ||
    !!mediaSession.source ||
    mediaSession.playing ||
    mediaSession.paused;

  if (!hasActiveMedia) return null;

  const status = mediaSession.buffering
    ? "Buffering"
    : mediaSession.playing
      ? "Playing"
      : mediaSession.paused
        ? "Paused"
        : "Ready";
  const sourceText = [mediaSession.source, mediaSession.channel]
    .filter(Boolean)
    .join(" · ");

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        left: 28,
        bottom: 28,
        zIndex: 2147482900,
        width: 340,
        pointerEvents: "none",
        userSelect: "none",
        display: "flex",
        alignItems: "center",
        gap: 13,
        padding: 12,
        borderRadius: 16,
        border: "1px solid rgba(255,255,255,0.16)",
        background: "rgba(8, 12, 22, 0.76)",
        color: "rgba(255,255,255,0.92)",
        boxShadow:
          "0 18px 48px rgba(0,0,0,0.46), inset 0 1px 0 rgba(255,255,255,0.12)",
        backdropFilter: "blur(16px) saturate(1.2)",
      }}
    >
      {mediaSession.artwork && (
        <img
          src={mediaSession.artwork}
          alt=""
          style={{
            width: 56,
            height: 56,
            borderRadius: 10,
            objectFit: "cover",
            flexShrink: 0,
            background: "rgba(255,255,255,0.08)",
          }}
        />
      )}

      <div style={{ minWidth: 0, flex: 1 }}>
        <div
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: 10,
            letterSpacing: 1.8,
            textTransform: "uppercase",
            color: mediaSession.playing
              ? "rgba(120,235,170,0.92)"
              : "rgba(229,199,93,0.9)",
            marginBottom: 5,
          }}
        >
          {status}
        </div>
        <div
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: 15,
            fontWeight: 700,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {mediaSession.title || "Untitled"}
        </div>
        {mediaSession.subtitle && (
          <div
            style={{
              marginTop: 3,
              fontFamily: "'Outfit', sans-serif",
              fontSize: 12,
              color: "rgba(255,255,255,0.62)",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {mediaSession.subtitle}
          </div>
        )}
        {sourceText && (
          <div
            style={{
              marginTop: 5,
              fontFamily: "'Outfit', sans-serif",
              fontSize: 11,
              color: "rgba(255,255,255,0.42)",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {sourceText}
          </div>
        )}
      </div>
    </div>
  );
}
